import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { genderI, genderTranslated } from '../../interfaces/currentUser';
import { DialogData } from '../../interfaces/dialog';
import { DialogService } from 'app/services/dialog.service';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  constructor(public dialog: DialogService) {}

  public openDialog(data: DialogData) {
    return this.dialog.openDialog(data);
  }

  public getEndPeriodo(dataInicio: any, days?: number) {
    if (!days) {
      days = 7;
    }
    if (!moment.isMoment(dataInicio)) {
      dataInicio = moment(dataInicio);
    }
    return dataInicio.add(days, 'days');
  }

  public getDayOfWeekName(code: any) {

    const daysOfWeek = [
      'Domingo',
      'Segunda',
      'Terça',
      'Quarta',
      'Quinta',
      'Sexta',
      'Sábado',
     
    ];

    return daysOfWeek[code];
  }

  public getMonthName(code: number) {
    const names = ['JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL', 'MAIO', 'JUNHO', 'JULHO', 'AGOSTO', 'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO'];
    return names[code];
  }

  public getMonthAbbr(code: number) {
    const names = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
    return names[code];
  }

  dateTimeFormat(date: any) {
    if (!moment.isMoment(date)) {
      date = moment(date, 'YYYY-MM-DD HH:mm');
    }
    return date.format('DD/MM/YYYY - HH:mm');
  }

  plannedStartHourFormat(date: any) {
    if (!moment.isMoment(date)) {
      date = moment(date, 'YYYY-MM-DD HH:mm');
    }
    return date.format('HH:mm');
  }

  dateFormat(date: any) {
    if (!moment.isMoment(date)) {
      date = moment(date, 'YYYY-MM-DD');
    }
    return date.format('DD/MM/YYYY');
  }

  getDatePtFormat(date: any) {
    return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
  }

  getDateDbFormat(date: any) {
    return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
  }

  getOnlyNumbers(value: any) {
    return value.replace(/\D+/g, '') as number;
  }

  initgender() {
    const genders: genderI[] = [
      { id: 'male', name: 'Male' },
      { id: 'female', name: 'Female' },
      { id: 'other', name: 'Other' },
      { id: 'unknow', name: 'Unknow' },
    ];
    return genders;
  }

  initTranslatedgender() {
    const genders: genderTranslated[] = [
      { id: 'male', name: 'Masculino' },
      { id: 'female', name: 'Feminino' },
      { id: 'other', name: 'Outro' },
    ];
    return genders;
  }
}
